import ApiService from '@/services/core/api.service'

const CommentService = {
  async get (payment, params = {}) {
    return ApiService.get(`disbursement-associate/payment-releasing/${payment}/comments`, { params })
  },

  async post (payment, payload) {
    return ApiService.post(`disbursement-associate/payment-releasing/${payment}/comments`, payload)
  },

  async put (payment, payload) {
    return ApiService.put(`disbursement-associate/payment-releasing/${payment}/comments/${payload.id}`, payload)
  },

  async delete (payment, payload) {
    return ApiService.delete(`disbursement-associate/payment-releasing/${payment}/comments/${payload.id}`, {
      data: payload
    })
  }
}

export default CommentService
